import type { AxiosInstance, AxiosRequestConfig } from 'axios'
import axios from 'axios'
import setupInterceptors from '@/api/interceptor'
import type { HttpParams } from '@/api/helper/http.define'
import { HttpMethodEnum } from '@/api/helper/http.define'

export const request: AxiosInstance = axios.create({
  // 前缀
  baseURL: '/',
  // 超时
  timeout: 1000 * 60,
  // 请求头
  headers: {
    'Content-Type': 'application/json'
  }
})

setupInterceptors(request.interceptors)

export default {
  get<T = never>(url: string, data?: HttpParams | FormData, config: AxiosRequestConfig = {}): Promise<T> {
    return request
      .get(url, {
        method: HttpMethodEnum.GET,
        params: data,
        ...config
      })
      .then((res) => {
        return res.data
      })
  },

  post<T = never>(url: string, data?: HttpParams | FormData, config: AxiosRequestConfig = {}): Promise<T> {
    return request.post(url, data, config).then((res) => {
      return res.data
    })
  },

  put<T = never>(url: string, data?: HttpParams | FormData, config: AxiosRequestConfig = {}): Promise<T> {
    return request.put(url, data, config).then((res) => {
      return res.data
    })
  },

  delete<T = never>(url: string, data?: HttpParams | FormData, config: AxiosRequestConfig = {}): Promise<T> {
    return request
      .delete(url, {
        method: HttpMethodEnum.DELETE,
        params: data,
        ...config
      })
      .then((res) => {
        return res.data
      })
  }
}
